import React from 'react';
import classNames from 'classnames';

import styles             from './Loading.css';
import { isMobileDevice } from '../../../utils';

export const GameLoading = (props: any) => (
    <LoaderContainer fullScreen = {isMobileDevice()}>
        <LoaderText>
            <LoadingLetter>L</LoadingLetter>
            <LoadingLetter>O</LoadingLetter>
            <LoadingLetter>A</LoadingLetter>
            <LoadingLetter>D</LoadingLetter>
            <LoadingLetter>I</LoadingLetter>
            <LoadingLetter>N</LoadingLetter>
            <LoadingLetter>G</LoadingLetter>
        </LoaderText>
    </LoaderContainer>
);

const LoaderContainer = ({fullScreen, ...props}: any) => (
    <div
        className = {classNames(
            styles.loaderContainer,
            {[styles.fullScreen]: fullScreen }
        )}
        {...props}
    />
);

const LoaderText = (props: any) => (
    <div className = {styles.loaderText} {...props} />
);

const LoadingLetter = (props: any) => (
    <span className = {styles.loadingLetter} {...props} />
);
